import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { PremiumDiff } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface DifferenceParams extends DefaultHttpHeaders {
  /** Identifier code of policy */
  policyId: string;
  /** Identifier code of the project */
  projectQuoteId: string;
  /** Identifier of the company who owns the final contract */
  companyId?: string;
}

@Injectable()
export class DifferenceService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Get policy's project premium difference
   * Get policy's project premium difference
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Policy/getPremiumDiff
   */
  difference(params: DifferenceParams): Observable<PremiumDiff[]> {
    const pathParams = {
      policyId: params.policyId,
      projectQuoteId: params.projectQuoteId,
    };
    const queryParams = {
      companyId: params.companyId,
    };

    return this.get<PremiumDiff[]>({
      suffix: `/home/policy/${pathParams.policyId}/project/${pathParams.projectQuoteId}/premium/difference`,
      queryParams,
      authenticationType: 'jwt',
    });
  }
}
